// below error codes are also defined in iam/auth/console/error_codes.py, please not modify the values
export const ERROR_INVITE_CODE_EXPIRED_AND_RESENT = 1000
export const ERROR_INVITE_CODE_EXPIRED = 1001
